<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="[activeTabName === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs" v-if="!tab.disabled">
					<span v-if="tab.disabled"><i :class="tab.icon"></i>{{ tab.displayName }}</span>
					<a @click.prevent="setActiveTabName(tab.name)" v-if="!tab.disabled"><i :class="tab.icon"></i> {{ tab.displayName }}</a>
				</li>
			</ul>
		</nav>
		<div class="main">
			<provider-list-container
					:dataProviderTypeId="providerTypeId"
					v-if="activeTabName === 'providers'">
			</provider-list-container>
			<provider-type-settings-container
					:dataProviderTypeId="providerTypeId"
					v-if="userRoles.includes('provider_types.update') && activeTabName === 'settings'">
			</provider-type-settings-container>
			<provider-type-groups-container
					:dataProviderTypeId="providerTypeId"
					v-if="userRoles.includes('provider_property.group.update') && activeTabName === 'properties'">
			</provider-type-groups-container>
			<provider-type-summary-settings
					:dataProviderTypeId="providerTypeId"
					v-if="userRoles.includes('provider_types.settings_update') && activeTabName === 'summary'">
			</provider-type-summary-settings>
			<provider-type-review-settings
					:dataProviderTypeId="providerTypeId"
					v-if="userRoles.includes('provider_types.settings_update') && activeTabName === 'review'">
			</provider-type-review-settings>
			<provider-type-meta-seo-container
					:dataProviderTypeId="providerTypeId"
					v-if="activeTabName === 'meta-seo'">
			</provider-type-meta-seo-container>
			<!--<provider-list-container
					:data-provider-list="providerList"
					:data-provider-type="providerType"
					v-if="activeTabName === 'providers'">
			</provider-list-container>
			<provider-type-settings-container
					:data-all-providers="allProviders"
					:data-provider-type="providerType"
					v-if="userRoles.includes('provider_types.update') && activeTabName === 'settings'">
			</provider-type-settings-container>
			<provider-type-groups-container
					:data-provider-type="providerType"
					v-if="userRoles.includes('provider_property.group.update') && activeTabName === 'properties'">
			</provider-type-groups-container>
			<provider-type-summary-settings
					:data-provider-type="providerType"
					v-if="userRoles.includes('provider_types.settings_update') && activeTabName === 'summary'">
			</provider-type-summary-settings>
			<provider-type-review-settings
					:data-provider-type="providerType"
					v-if="userRoles.includes('provider_types.settings_update') && activeTabName === 'review'">
			</provider-type-review-settings>
			<provider-type-meta-seo-container
					:data-provider-type="providerType"
					v-if="activeTabName === 'meta-seo'">
			</provider-type-meta-seo-container>-->
		</div>

		<loader></loader>
	</div>
</template>

<script>
	export default {
		props: {
			dataprovidertypeid: {
				type: Number
			}
		},
		data() {
			return {
				providerTypeId: this.dataprovidertypeid,
				userRoles: this.$currentUserRoles,
				tabs: [
					{
						name: 'providers',
						displayName: 'Providers',
						icon: 'fas fa-list',
						disabled: false
					},
					{
						name: 'settings',
						displayName: 'Settings',
						icon: 'fas fa-cog',
						disabled: !this.$currentUserRoles.includes('provider_types.update')
					},
					{
						name: 'properties',
						displayName: 'Properties',
						icon: 'fas fa-tasks',
						disabled: !this.$currentUserRoles.includes('provider_property.group.update')
					},
					{
						name: 'summary',
						displayName: 'Summary',
						icon: 'far fa-window-maximize',
						disabled: !this.$currentUserRoles.includes('provider_types.settings_update')
					},
					{
						name: 'review',
						displayName: 'Review Settings',
						icon: 'fas fa-sliders-h',
						disabled: !this.$currentUserRoles.includes('provider_types.settings_update')
					},
					{
						name: 'meta-seo',
						displayName: 'Meta & SEO',
						icon: 'fas fa-search-dollar',
						disabled: false
					}
				],
				activeTabName: null,
			}
		},
		created() {
			let url_string = window.location.href;
			let url = new URL(url_string);
			this.activeTabName = url.searchParams.get("tab");
		},
		mounted() {
			this.activeTabName = this.activeTabName ? this.activeTabName : this.tabs[0].name;
		},
		methods: {

			setActiveTabName: function (name) {
				this.activeTabName = name;
				window.history.replaceState('', '', this.updateURLParameter(window.location.href, 'tab', name));
			},
			updateURLParameter: function (url, param, paramVal) {
				let newAdditionalURL = "";
				let tempArray = url.split("?");
				let baseURL = tempArray[0];
				let additionalURL = tempArray[1];
				let temp = "";
				if (additionalURL) {
					tempArray = additionalURL.split("&");
					for (var i = 0; i < tempArray.length; i++) {
						if (tempArray[i].split('=')[0] != param) {
							newAdditionalURL += temp + tempArray[i];
							temp = "&";
						}
					}
				}

				let rows_txt = temp + "" + param + "=" + paramVal;
				return baseURL + "?" + newAdditionalURL + rows_txt;
			}
		}
	}
</script>

<style scoped>

</style>
